module.exports = __webpack_public_path__ + "img/Slide6.d5713c6a.png";